import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { paymentClient } from "@core/clients";
import { PayWithSavedMethodInput } from "@core/types";

type PayWithSavedMethodMutation = UseMutationOptions<any, any, PayWithSavedMethodInput>;

const usePayWithSavedMethodMutation = (props?: PayWithSavedMethodMutation) => {
  return useMutation(
    ["pay-with-saved-method"],
    async (paymentId) => await paymentClient.payWithSavedMethod(paymentId),
    {
      ...props,
    },
  );
};

export default usePayWithSavedMethodMutation;
